import React from 'react';
import { Hand, Navigation, ZoomIn, ZoomOut, Undo2, Redo2, Locate, Frame } from 'lucide-react';
import { C, FONT_UI } from '../../constants/design-tokens';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { ToolBtn } from '../../shared/ui/tool-btn';
import { ToolbarSeparator } from '../../shared/ui/toolbar-separator';

export const CanvasControls: React.FC = () => {
  const {
    zoom,
    zoomIn,
    zoomOut,
    fitToContainer,
    undo,
    redo,
    canUndo,
    canRedo,
    activeTool,
    setActiveTool,
    clipToCanvas,
    setClipToCanvas
  } = useEditorCanvas();

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '2px',
        padding: '6px 12px',
        background: C.bg,
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.10)',
        border: `1px solid ${C.panelBorder}`
      }}
    >
      {/* Undo / Redo */}
      <ToolBtn onClick={undo} title='Deshacer' disabled={!canUndo}>
        <Undo2 size={16} />
      </ToolBtn>
      <ToolBtn onClick={redo} title='Rehacer' disabled={!canRedo}>
        <Redo2 size={16} />
      </ToolBtn>

      <ToolbarSeparator />

      {/* Zoom */}
      <ToolBtn onClick={zoomOut} title='Alejar'>
        <ZoomOut size={16} />
      </ToolBtn>
      <span
        style={{
          minWidth: '40px',
          textAlign: 'center',
          fontSize: '13px',
          fontFamily: FONT_UI,
          color: C.textPrimary,
          fontWeight: 500,
          userSelect: 'none'
        }}
      >
        {Math.round(zoom * 100)}%
      </span>
      <ToolBtn onClick={zoomIn} title='Acercar'>
        <ZoomIn size={16} />
      </ToolBtn>

      <ToolbarSeparator />

      <ToolBtn onClick={fitToContainer} title='Centrar'>
        <Locate size={16} />
      </ToolBtn>

      <ToolBtn
        onClick={() => setClipToCanvas(!clipToCanvas)}
        title={clipToCanvas ? 'Mostrar overflow del canvas' : 'Recortar al canvas (preview)'}
        active={clipToCanvas}
      >
        <Frame size={16} />
      </ToolBtn>

      {/* Tools */}
      <ToolBtn
        onClick={() => setActiveTool(activeTool === 'pan' ? 'select' : 'pan')}
        title='Mover canvas'
        active={activeTool === 'pan'}
      >
        <Hand size={16} />
      </ToolBtn>
      <ToolBtn onClick={() => setActiveTool('select')} title='Seleccionar' active={activeTool === 'select'}>
        <Navigation size={16} />
      </ToolBtn>
    </div>
  );
};
